import configureStore from './configureStore.js';

export default configureStore;
